import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CategorySkeleton = React.memo(() => {
  return (
    <div className="text-decoration-none category-link col-lg-2 col-md-4 col-sm-12">
      <Skeleton height={20} width="80%" className="mb-1" />
      <Skeleton height={16} width="40%" />
    </div>
  );
});

export default CategorySkeleton;
